import { c as _c } from "react/compiler-runtime";
import { useInfiniteQuery } from "@tanstack/react-query";
import { accountAxiosInstance } from "@/services/axios";
import { useUser } from "@/contexts/user-context";
export interface Address {
  id: number;
  first_name: string;
  last_name: string;
  street_address_1: string;
  street_address_2: string;
  landmark: string;
  city: string;
  location: string;
  longitude: number;
  latitude: number;
  label: string;
  pincode: string;
  is_default?: boolean;
  user?: number;
  house_no_floor?: string;
  building_block_no?: string;
  street?: string;
  state?: string;
  country?: string;
  mobile_number?: string;
  phone_number?: string;
  email?: string;
}
interface AddressResponse {
  count: number;
  next: string | null;
  previous: string | null;
  results: Address[];
}
export const useAddresses = () => {
  const $ = _c(16);
  const {
    isAuthenticated
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["addresses"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== isAuthenticated) {
    t1 = {
      queryKey: t0,
      queryFn: _temp,
      getNextPageParam: _temp2,
      initialPageParam: 1,
      staleTime: 300000,
      gcTime: 600000,
      enabled: isAuthenticated
    };
    $[1] = isAuthenticated;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
    isError,
    error,
    refetch,
    isFetching
  } = useInfiniteQuery(t1);
  let t2;
  if ($[3] !== data?.pages) {
    t2 = data?.pages.flatMap(_temp3) ?? [];
    $[3] = data?.pages;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const addresses = t2;
  const totalCount = data?.pages[0]?.count ?? 0;
  let t3;
  if ($[5] !== addresses || $[6] !== error || $[7] !== fetchNextPage || $[8] !== hasNextPage || $[9] !== isError || $[10] !== isFetching || $[11] !== isFetchingNextPage || $[12] !== isLoading || $[13] !== refetch || $[14] !== totalCount) {
    t3 = {
      addresses,
      totalCount,
      fetchNextPage,
      hasNextPage,
      isFetchingNextPage,
      isLoading,
      isError,
      error,
      refetch,
      isFetching
    };
    $[5] = addresses;
    $[6] = error;
    $[7] = fetchNextPage;
    $[8] = hasNextPage;
    $[9] = isError;
    $[10] = isFetching;
    $[11] = isFetchingNextPage;
    $[12] = isLoading;
    $[13] = refetch;
    $[14] = totalCount;
    $[15] = t3;
  } else {
    t3 = $[15];
  }
  return t3;
};
async function _temp(t0) {
  const {
    pageParam: t1
  } = t0;
  const pageParam = t1 === undefined ? 1 : t1;
  const response = await accountAxiosInstance.get("/user-addresses/", {
    params: {
      page: pageParam
    }
  });
  return response.data;
}
function _temp2(lastPage) {
  if (!lastPage.next) {
    return;
  }
  const url = new URL(lastPage.next);
  const page = url.searchParams.get("page");
  return page ? parseInt(page) : undefined;
}
function _temp3(page_0) {
  return page_0.results;
}